import { EventsCalendar } from "../../../layout/organisation/EventsCalendar";
import { useOrganisation } from "../../../providers/OrganisationProvider";
import { EventsCalendarPageSkeleton } from "./EventsCalendarPageSkeleton";

const EventsCalendarPage = () => {
    const organisation = useOrganisation();

    if (!organisation) return <EventsCalendarPageSkeleton />;
    return <EventsCalendar events={organisation.events} />;
};
export default EventsCalendarPage;
